import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const SectionBoxStyles = styled(Box)(
  ({
    theme,
    iconColor,
    iconBorderColor,
    iconFontSize,
    iconMarginRight,
    cursor,
    boxbackgroundColor,
  }) => ({
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2.5),
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: theme.spacing(2),
    alignItems: "center",
    cursor: cursor || "",
    borderRadius: "16px",
    boxShadow: theme.shadows.main,
    height: '100%',
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#E3E9F7",
    },

    "& .mainBoxesContainer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },

    "& .icon-box": {
      marginRight: theme.spacing(2),
      border: `2px solid ${iconBorderColor || "transparent"}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
      backgroundColor: boxbackgroundColor || theme.palette.text.secondary,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    "& .icon": {
      marginRight: iconMarginRight || theme.spacing(2), 
      color: iconColor || theme.palette.text.secondary,
      border: `1px solid ${iconBorderColor || "transparent"}`,
      backgroundColor: boxbackgroundColor || theme.palette.text.secondary,
      padding: theme.spacing(1),
      fontSize: iconFontSize || theme.typography.pxToRem(60),
      borderRadius: "7px",
    },

    "& .title": {
      color: theme.palette.text.secondary,
      fontWeight: "500",
    },

    "& .number": {
      fontWeight: "bold",
    },
  })
);
